import React from 'react';
import { Activity } from 'lucide-react';
import { AudioEffect, AudioEffectControlProps } from './AudioEffect';

export interface CompressorConfig {}

class CompressorEffectImpl extends AudioEffect<CompressorConfig> {
  readonly id = 'compressor';
  readonly label = 'Compresseur';
  readonly icon = Activity;
  readonly description = 'Compresseur dynamique';
  readonly defaultConfig: CompressorConfig = {};
  readonly disabled = true;
  readonly disabledReason = 'Bientôt disponible';

  renderControls(_props: AudioEffectControlProps<CompressorConfig>) {
    return (
      <div style={{ fontSize: 11, color: 'rgba(148,163,184,0.6)' }}>
        Compresseur dynamique — pas encore branché au pipeline audio.
      </div>
    );
  }
}

export const compressorEffect = new CompressorEffectImpl();
